module.exports = __webpack_public_path__ + "media/images/button-next-e749f3166b84a48c4b298884d63359b4.svg";